import { PlanType } from '@showbie-socrative/socrative-utils';

/**
 * Maps the enum to user friendly names.
 * NOTE they are not localized.
 * complete organization show as organization
 * pro and legacy pro show as pro
 * free and free legacy show as free
 */
export const planNameMap: Record<PlanType, string> = {
  complete: 'Organization',
  organization: 'Organization',
  free: 'Free',
  free_legacy: 'Free',
  legacy_pro: 'Pro',
  pro: 'Pro',
  starter: 'Starter',
  essentials: 'Essentials',
};
